import { navData } from "./modules/data";
import Logo from "./images/logo.svg";
import Hero from "./images/illustration-working.svg";

export default function Header() {
  const ListItems = navData.map((data) => (
    <li key={data.id}>
      <a>{data.title}</a>
    </li>
  ));
  return (
    <>
      <header>
        <nav className="app__nav-section">
          <div>
            <img src={Logo} alt="Logo" />
            <ul>{ListItems}</ul>
          </div>
          <div>
            <a href="/">Login</a>
            <a href="/">Signup</a>
          </div>
        </nav>
        <section className="app__hero-section">
          <div>
            <h1>More than just shorter links</h1>
            <p>
              Build your brand’s recognition and get detailed insights on how
              your links are performing.
            </p>
            <button>Get Started</button>
          </div>
          <div>
            <img src={Hero} alt="" />
          </div>
        </section>
      </header>
    </>
  );
}
